import React, {
  useEffect,
  useState,
} from "react";

import {
  useLocation,
} from "react-router-dom";

import {
  FiSearch,
  FiEdit,
  FiTrash2,
  FiDownload,
} from "react-icons/fi";

import {
  FaUserTie,
  FaBuilding,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";

import Swal from "sweetalert2";

import dayjs from "dayjs";

import * as XLSX from "xlsx";

import {
  jsPDF,
} from "jspdf";

import "jspdf-autotable";

import {
  getData,
  putData,
  deleteData,
} from "../../../services/FetchNodeservices";

export default function TodaysCandidateReport() {

  // =================================================
  // LOCATION
  // =================================================

  const location =
    useLocation();

  // =================================================
  // STATES
  // =================================================

  const [data, setData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [page, setPage] =
    useState(1);

  const rowsPerPage = 10;

const [filters, setFilters] =
  useState({

    search: "",

    status: "",

    position: "",

    date: "",

    todayOnly: false,
  });

  // =================================================
  // LOAD DATA
  // =================================================

  useEffect(() => {

    loadData();

  }, []);

  // =================================================
  // URL FILTER
  // =================================================

useEffect(() => {

  const params =
    new URLSearchParams(
      location.search
    );

  const filter =
    params.get("filter");

  if (
    filter === "today"
  ) {

    setFilters(
      (prev) => ({

        ...prev,

        todayOnly: true,

        date:
          dayjs().format(
            "YYYY-MM-DD"
          ),
      })
    );
  }

}, [location.search]);

  // =================================================
  // FETCH
  // =================================================

  const loadData =
    async () => {

      try {

        setLoading(true);

        const result =
          await getData(
            "candidate"
          );

        if (
          result?.status
        ) {

          setData(
            result.data || []
          );
        }

      } catch {

        Swal.fire(
          "Error",
          "Failed to load candidates",
          "error"
        );

      } finally {

        setLoading(false);
      }
    };

  // =================================================
  // FILTERED DATA
  // =================================================
const filteredData =
  data.filter(
    (row) => {

      const search =
        filters.search.toLowerCase();

      const fullName =
        `${row.f_name || ""} ${row.l_name || ""}`;

      const matchesSearch =

        fullName
          .toLowerCase()
          .includes(search) ||

        row.email_id
          ?.toLowerCase()
          .includes(search) ||

        row.phone_number
          ?.toLowerCase()
          .includes(search) ||

        row.designation
          ?.toLowerCase()
          .includes(search);

      const matchesStatus =

        !filters.status ||

        row.status ===
          filters.status;

      const matchesPosition =

        !filters.position ||

        row.designation ===
          filters.position;

      // =================================================
      // DATE FILTER
      // =================================================

      let matchesDate =
        true;

      if (
        filters.date
      ) {

        matchesDate =

          dayjs(
            row.uploaded_on
          ).format(
            "YYYY-MM-DD"
          ) ===
          filters.date;
      }

      return (

        matchesSearch &&

        matchesStatus &&

        matchesPosition &&

        matchesDate
      );
    }
  );

  // =================================================
  // PAGINATION
  // =================================================

  const paginated =
    filteredData.slice(

      (page - 1) *
        rowsPerPage,

      page *
        rowsPerPage
    );

  // =================================================
  // EXPORT EXCEL
  // =================================================

  const exportExcel =
    () => {

      const ws =
        XLSX.utils.json_to_sheet(
          filteredData
        );

      const wb =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        wb,
        ws,
        "Candidates"
      );

      XLSX.writeFile(
        wb,
        "Candidates.xlsx"
      );
    };

  // =================================================
  // EXPORT PDF
  // =================================================

  const exportPDF =
    () => {

      const doc =
        new jsPDF();

      doc.text(
        "Candidate Report",
        14,
        15
      );

      doc.autoTable({

        head: [[

          "Candidate",

          "Email",

          "Phone",

          "Position",

          "Status",
        ]],

        body:
          filteredData.map(
            (r) => ([

              `${r.f_name} ${r.l_name}`,

              r.email_id,

              r.phone_number,

              r.designation,

              r.status,
            ])
          ),
      });

      doc.save(
        "Candidate_Report.pdf"
      );
    };

  // =================================================
  // DELETE
  // =================================================

  const deleteCandidate =
    async (id) => {

      Swal.fire({

        title:
          "Delete Candidate?",

        icon:
          "warning",

        showCancelButton:
          true,
      }).then(
        async (res) => {

          if (
            res.isConfirmed
          ) {

            await deleteData(
              `candidate/${id}`
            );

            loadData();
          }
        }
      );
    };

  return (

    <div className="md:ml-72 pt-24 px-4 md:px-6 pb-8 min-h-screen text-slate-800">

      {/* HEADER */}

      <div className="flex items-center justify-between mb-6">

        <div>

          <h1 className="text-2xl font-semibold">
            Candidate Report
          </h1>

          <p className="text-sm text-gray-500 mt-1">
            Candidate pipeline management
          </p>
        </div>

        <div className="flex gap-3">

          <button
            onClick={
              exportExcel
            }
            className="
              bg-black
              text-white
              px-4
              py-2
              rounded-2xl
              text-sm
            "
          >
            Excel
          </button>

          <button
            onClick={
              exportPDF
            }
            className="
              border
              border-gray-300
              px-4
              py-2
              rounded-2xl
              text-sm
            "
          >
            PDF
          </button>
        </div>
      </div>

      {/* FILTERS */}

      <div className="glass-card p-4 mb-6">

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <input
  type="date"
  value={
    filters.date
  }
  onChange={(e) =>
    setFilters({

      ...filters,

      date:
        e.target.value,
    })
  }
  className="glass-input px-4 py-2.5 rounded-2xl text-sm outline-none"
/>

          <div className="glass-input flex items-center gap-3 rounded-2xl px-4 py-2.5">

            <FiSearch className="text-gray-400" />
            

            <input
              type="text"
              placeholder="Search..."
              value={
                filters.search
              }
              onChange={(e) =>
                setFilters({

                  ...filters,

                  search:
                    e.target.value,
                })
              }
              className="w-full bg-transparent outline-none text-sm text-slate-800 dark:text-slate-200"
            />
          </div>

          <select
            value={
              filters.status
            }
            onChange={(e) =>
              setFilters({

                ...filters,

                status:
                  e.target.value,
              })
            }
            className="glass-input px-4 py-2.5 rounded-2xl text-sm outline-none"
          >

            <option value="">
              All Status
            </option>

            {[...new Set(
              data.map(
                (x) =>
                  x.status
              )
            )].map(
              (item) => (

                <option
                  key={item}
                  value={item}
                >
                  {item}
                </option>
              )
            )}
          </select>

          <select
            value={
              filters.position
            }
            onChange={(e) =>
              setFilters({

                ...filters,

                position:
                  e.target.value,
              })
            }
            className="glass-input px-4 py-2.5 rounded-2xl text-sm outline-none"
          >

            <option value="">
              All Positions
            </option>

            {[...new Set(
              data.map(
                (x) =>
                  x.designation
              )
            )].map(
              (item) => (

                <option
                  key={item}
                  value={item}
                >
                  {item}
                </option>
              )
            )}
          </select>

          <button
            onClick={() =>
              setFilters({

                search: "",

                status: "",

                position: "",

                todayOnly: false,
              })
            }
            className="
              border
              border-gray-300
              rounded-2xl
              px-4
              py-3
              text-sm
            "
          >
            Reset Filters
          </button>
        </div>
      </div>

      {/* TABLE */}

      <div className="glass-card overflow-hidden">

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="bg-slate-50 dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700">

              <tr>

                {[
                  "Candidate",
                  "Contact",
                  "Position",
                  "Experience",
                  "Status",
                  "Uploaded",
                  "Action",
                ].map(
                  (head) => (

                    <th
                      key={head}
                      className="
                        px-5
                        py-4
                        text-left
                        text-xs
                        font-semibold
                        text-gray-500
                      "
                    >
                      {head}
                    </th>
                  )
                )}
              </tr>
            </thead>

            <tbody>

              {loading ? (

                <tr>

                  <td
                    colSpan={7}
                    className="
                      text-center
                      py-10
                    "
                  >
                    Loading...
                  </td>
                </tr>

              ) : paginated.length === 0 ? (

                <tr>

                  <td
                    colSpan={7}
                    className="
                      text-center
                      py-10
                    "
                  >
                    No Candidates Found
                  </td>
                </tr>

              ) : (

                paginated.map(
                  (
                    row,
                    index
                  ) => (

                    <tr
                      key={index}
                      className="
                        border-b
                        border-gray-100
                        hover:bg-[#fafafa]
                      "
                    >

                      {/* CANDIDATE */}

                      <td className="px-5 py-4">

                        <div className="flex items-center gap-3">

                          <div
                            className="
                              w-10
                              h-10
                              rounded-2xl
                              bg-black
                              text-white
                              flex
                              items-center
                              justify-center
                            "
                          >
                            <FaUserTie />
                          </div>

                          <div>

                            <h3 className="text-sm font-medium">
                              {row.f_name} {row.l_name}
                            </h3>

                            <p className="text-xs text-gray-500">
                              {row.current_company}
                            </p>
                          </div>
                        </div>
                      </td>

                      {/* CONTACT */}

                      <td className="px-5 py-4">

                        <div className="space-y-1">

                          <div className="flex items-center gap-2 text-sm">

                            <FaEnvelope className="text-gray-400" />

                            {row.email_id}
                          </div>

                          <div className="flex items-center gap-2 text-xs text-gray-500">

                            <FaPhone className="text-gray-400" />

                            {row.phone_number}
                          </div>
                        </div>
                      </td>

                      {/* POSITION */}

                      <td className="px-5 py-4 text-sm">
                        {row.designation}
                      </td>

                      {/* EXPERIENCE */}

                      <td className="px-5 py-4 text-sm">
                        {row.experience} Years
                      </td>

                      {/* STATUS */}

                      <td className="px-5 py-4">

                        <span
                          className="
                            px-3
                            py-1
                            rounded-full
                            text-xs
                            font-medium
                            bg-black
                            text-white
                          "
                        >
                          {row.status}
                        </span>
                      </td>

                      {/* DATE */}

                      <td className="px-5 py-4 text-sm">
                        {
                          row.uploaded_on
                            ? dayjs(
                                row.uploaded_on
                              ).format(
                                "YYYY-MM-DD"
                              )
                            : "-"
                        }
                      </td>

                      {/* ACTION */}

                      <td className="px-5 py-4">

                        <div className="flex gap-2">

                          <button
                            className="
                              w-9
                              h-9
                              rounded-xl
                              bg-black
                              text-white
                              flex
                              items-center
                              justify-center
                            "
                          >
                            <FiEdit size={14} />
                          </button>

                          <button
                            onClick={() =>
                              deleteCandidate(
                                row.candidate_id
                              )
                            }
                            className="
                              w-9
                              h-9
                              rounded-xl
                              border
                              border-red-200
                              text-red-500
                              flex
                              items-center
                              justify-center
                            "
                          >
                            <FiTrash2 size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}